export enum SchoolRequestEnums {
  SCHOOL_REQUEST = 'school-request',
}
